import { Location } from "history";
import React from "react";

import { MorePosts, MorePostsPlaceholder } from "@/mk2/apps/forum/components/MorePosts";
import { UnsatisfiedWithResultsTryForum } from "@/mk2/apps/forum/components/UnsatisfiedWithResultsTryForum";
import { ForumMessageEntity, PostEntity } from "@/mk2/apps/forum/schemas";
import { Panel } from "@/mk2/components/Panel";
import { RenderAST } from "@/mk2/components/RenderAST";
import { AdSlot } from "@/mk2/containers/AdSlot/AdSlot";
import { ShowPhotosAndVideos } from "@/mk2/helpers/article_ast/filters";
import { cacheLast } from "@/mk2/helpers/cache";
import { ContentItemEntity, UserEntity } from "@/mk2/schemas";
import {
    FORUM_RECENT_POSTS,
    FORUM_RELATED_DISCUSSIONS,
    FORUM_SIMILAR_DISCUSSIONS,
    RELATED_DISCUSSIONS_IN_FORUM,
    YOUTUBE_MK_TITLE,
} from "@/mk/autogenerated/translations/PostDetailRelated.a495b06fb70d1fd56bba678e1dfee812";

import styles from "./PostDetailRelated.mscss";

interface OwnProps {
    isAskAnExpert: boolean;
    isContest: boolean;
    isMobile: boolean;
    location: Location;
    post: PostEntity;
    comments: ForumMessageEntity[];
    requestUser: UserEntity;
    similarPosts: PostEntity[];
    recentPosts: PostEntity[];
    backlinksBox: ContentItemEntity;
}

export class PostDetailRelated extends React.PureComponent<OwnProps> {
    private trackEventPropsCache = cacheLast();

    public render() {
        const {
            requestUser,
            isAskAnExpert,
            isContest,
            isMobile,
            location,
            post,
            similarPosts,
            recentPosts,
            backlinksBox,
            comments,
        } = this.props;

        const recentPostsFiltered = recentPosts.filter((obj) => obj !== post);
        const hasAds = !post.deletedAt && !post.isNoAds && !post.topic.isCommercial;

        return (
            <>
                {!isContest &&
                    !isAskAnExpert &&
                    hasAds &&
                    comments?.length >= 5 &&
                    this.renderRectangleAd()}
                {!isContest && !isAskAnExpert && !isMobile && (
                    <MorePosts
                        key="similar"
                        className={styles.PostDetailRelated__box}
                        posts={similarPosts.slice(0, 6)}
                        title={FORUM_SIMILAR_DISCUSSIONS}
                        headingLevel={2}
                        trackEventProps={
                            post &&
                            this.trackEventPropsCache(
                                {
                                    name: "forum_related_click",
                                    props: {
                                        post_slug: post.slug,
                                        placement: "desktop_sidebar",
                                    },
                                },
                                post.slug,
                                "similar",
                            )
                        }
                    />
                )}
                {backlinksBox && !isContest && !isAskAnExpert && (
                    <Panel className={styles.PostDetailRelated__backlinksBox}>
                        <RenderAST
                            contentAST={backlinksBox.contentAST}
                            linkedObjects={backlinksBox.contentASTAdditionalData.linkedObjects}
                            showPhotosAndVideos={ShowPhotosAndVideos.ALL}
                            renderSpecialWikiLinks={false}
                            customStyles={{
                                paragraph: styles.PostDetailRelated__backlinksBox__p,
                                unorderedlist: styles.PostDetailRelated__backlinksBox__ul,
                            }}
                        />
                    </Panel>
                )}
                {!isContest && isAskAnExpert && (
                    <MorePosts
                        key="recent"
                        className={styles.PostDetailRelated__box}
                        posts={recentPostsFiltered}
                        showComments={!isAskAnExpert}
                        title={FORUM_RECENT_POSTS}
                        headingLevel={2}
                        trackEventProps={
                            post &&
                            this.trackEventPropsCache(
                                {
                                    name: "counselling_recent_posts_click",
                                    props: {
                                        post_slug: post.slug,
                                        topic_slug: post.topic.slug,
                                        category_slug: post.topic.category.slug,
                                        post_url: location.pathname,
                                    },
                                },
                                location.pathname,
                                "recent",
                            )
                        }
                    />
                )}
                {isAskAnExpert && hasAds && comments?.length >= 5 && this.renderRectangleAd()}
                {!isContest && isAskAnExpert && (
                    <MorePosts
                        key="related"
                        className={styles.PostDetailRelated__box}
                        posts={similarPosts}
                        title={RELATED_DISCUSSIONS_IN_FORUM}
                        headingLevel={2}
                        trackEventProps={
                            post &&
                            this.trackEventPropsCache(
                                {
                                    name: "counselling_more_similar_posts_click",
                                    props: {
                                        post_slug: post.slug,
                                        topic_slug: post.topic.slug,
                                        category_slug: post.topic.category.slug,
                                        post_url: location.pathname,
                                    },
                                },
                                location.pathname,
                                "related",
                            )
                        }
                    />
                )}
                {/* {!isContest && !isMobile && this.renderRectangle1Ad()} */}
                {!isContest && !isAskAnExpert && !isMobile && (
                    <UnsatisfiedWithResultsTryForum
                        requestUser={requestUser}
                        className={styles.PostDetailRelated__box}
                    />
                )}
            </>
        );
    }

    private renderRectangleAd = () => {
        const { location, isMobile } = this.props;

        return (
            <AdSlot
                key="advertisement"
                zone={isMobile ? "Forum - Other 01 - Mobile" : "Forum - Top 02 - Desktop"}
                location={location}
                marginTopWithAd={10}
                marginBottomWithAd={10}
            />
        );
    };

    // private renderRectangle1Ad = () => {
    //     const { location } = this.props;

    //     return (
    //         <AdSlot
    //             key="rectangle1-advertisement"
    //             zone="Forum - Top 03 - Desktop"
    //             location={location}
    //             marginBottomWithAd={10}
    //         />
    //     );
    // };
}

interface PlaceholderOwnProps {
    isAskAnExpert: boolean;
    isContest: boolean;
    requestUser: UserEntity;
}

export class PostDetailRelatedPlaceholder extends React.PureComponent<PlaceholderOwnProps> {
    public render() {
        const { isAskAnExpert, isContest, requestUser } = this.props;

        return (
            <>
                {!isContest && !isAskAnExpert && (
                    <MorePostsPlaceholder
                        key="similar"
                        className={styles.PostDetailRelated__box}
                        title={FORUM_SIMILAR_DISCUSSIONS}
                    />
                )}
                {!isContest && !isAskAnExpert && (
                    <MorePostsPlaceholder
                        key="youtube1"
                        className={styles.PostDetailRelated__box}
                        title={YOUTUBE_MK_TITLE}
                    />
                )}
                {!isContest && isAskAnExpert && (
                    <MorePostsPlaceholder
                        key="recent"
                        className={styles.PostDetailRelated__box}
                        title={FORUM_RECENT_POSTS}
                    />
                )}
                {isAskAnExpert && (
                    <MorePostsPlaceholder
                        key="youtube2"
                        className={styles.PostDetailRelated__box}
                        title={YOUTUBE_MK_TITLE}
                    />
                )}
                {!isContest && isAskAnExpert && (
                    <MorePostsPlaceholder
                        key="related"
                        className={styles.PostDetailRelated__box}
                        title={FORUM_RELATED_DISCUSSIONS}
                    />
                )}
                {!isAskAnExpert && (
                    <UnsatisfiedWithResultsTryForum
                        requestUser={requestUser}
                        className={styles.PostDetailRelated__box}
                    />
                )}
            </>
        );
    }
}
